var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.536006 20.386C0.697771 20.4702 0.879397 20.5087 1.06139 20.4974C1.24338 20.4861 1.41886 20.4255 1.56901 20.322L14.569 11.322C14.7018 11.23 14.8104 11.1071 14.8854 10.964C14.9604 10.8208 14.9995 10.6616 14.9995 10.5C14.9995 10.3384 14.9604 10.1792 14.8854 10.0361C14.8104 9.89291 14.7018 9.77006 14.569 9.67803L1.56901 0.678027C1.41915 0.573482 1.24346 0.512086 1.0611 0.500532C0.878744 0.488979 0.696714 0.527712 0.534858 0.612509C0.373002 0.697305 0.237532 0.82491 0.143218 0.981412C0.0489047 1.13791 -0.000633163 1.3173 6.10981e-06 1.50003V19.5C-2.39712e-05 19.6826 0.0499091 19.8616 0.144393 20.0178C0.238878 20.174 0.374308 20.3013 0.536006 20.386ZM2.00001 3.40903L12.243 10.5L2.00001 17.591V3.40903Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0b9fce5f3ddb323eaf202f46195f0f3b.svg";
export { ForwardRef as ReactComponent };